import { Theme, createStyles, makeStyles } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardContent: {
      padding: theme.spacing(3),
    },
    button: {
      width: '100%',
    },
    disclaimer: {
      maxWidth: 600,
      padding: theme.spacing(2, 2, 2),
    },
    modalButtons: {
      float: 'right',
      marginRight: '1em',
    },
  })
);
